import React from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

import {UtilisationGridRow} from "./UtilisationGridRow.tsx";

export function SortableUtilisationGridRow({dragId, ...props}) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
        isOver

    } = useSortable({id: dragId});

    // const style = {
    //     transform: CSS.Transform.toString(transform),
    //     height: 23,
        // transition,
    // };


    // if (isOver) {
    //     console.log('over');
    //     console.log(dragId);
    // }
    if (isDragging) {
        console.log('is draggin');
        console.log(transform);
        console.log(transition);
        console.log(dragId);
    }

    return (
        // <UtilisationGridRow {...props} ref={setNodeRef} style={style} {...attributes} {...listeners} />
        <UtilisationGridRow {...props} ref={setNodeRef} {...attributes} {...listeners} isOver={isOver} transform={transform} />
    );
}